import React from "react";

const Spinner = () => {
  return (
    <div className="relative flex justify-center w-full">
      <div
        className="w-4 h-4 border rounded-full animate-spin"
        style={{
          borderTopColor: "white",
        }}
      ></div>
    </div>
  );
};

export default Spinner;
